/**
 * LA POLICE DES MATHÉMATIQUES de la console — un seul endroit, comme
 * `apps/mobile/src/components/policeMath.ts` l'est pour l'application
 * (tranche T2 : la console s'aligne sur la variante A, « le manuel scolaire »).
 *
 * VARIANTE A : STIX Two Text, graisse Medium (licence SIL OFL 1.1) — chiffres
 * droits, variables en italique — et, pour les quelques signes qu'elle ne
 * porte pas (`≠ ≤ ≥ ≈ →`), STIX Two Math. Ce sont LES MÊMES TROIS FICHIERS que
 * ceux de l'application (`apps/mobile/assets/polices/`, 52 Ko à eux trois,
 * réduits au jeu de caractères des mathématiques) : `theme.css` les déclare
 * depuis ce dossier, sans les recopier.
 *
 * ─── La métrique se choisit du même geste ───────────────────────────────────
 *
 * `disposerMath` pose les glyphes à l'avance LUE dans ces fichiers
 * (`METRIQUE_MANUEL`). Jusqu'ici la console dessinait en IBM Plex Mono, avec
 * la métrique à chasse fixe (le défaut) : charger la police sans changer la
 * métrique décollerait les exposants, et l'inverse aussi. Ce module fait donc
 * les deux, AU CHARGEMENT — tout ce qui peint une écriture posée l'importe
 * (`FormuleWeb`, donc `DessinWeb` et `ExempleAnnoteWeb`).
 *
 * ─── Ce que ce module ne règle PAS ──────────────────────────────────────────
 *
 * Les formules DANS UNE PHRASE (`TexteMaths`) sont du MathML, mis en page par
 * le navigateur : il lui faut une police mathématique COMPLÈTE (table `MATH`,
 * alphabet italique mathématique, radicaux et parenthèses extensibles), que le
 * sous-ensemble de l'application ne porte pas. `theme.css` y nomme
 * « STIX Two Math », présente sur macOS et iPadOS, puis les polices
 * mathématiques du système : sur un poste qui ne l'a pas, la prose garde la
 * police du navigateur. Livrer STIX Two Math en entier est une décision à
 * prendre (un fichier de plusieurs centaines de Ko, absent du dépôt).
 */
import { METRIQUE_MANUEL, choisirMetriqueMath, type PoliceGlypheMath } from '@silex/shared';

choisirMetriqueMath(METRIQUE_MANUEL);

/**
 * La classe d'un glyphe de la liste d'affichage : `theme.css` y attache la
 * police. Sans `police` : la police droite des mathématiques.
 */
export function classeDuGlyphe(police: PoliceGlypheMath | undefined): string {
  switch (police) {
    case 'italique':
      return 'fiche-glyphe fiche-glyphe--italique';
    case 'symbole':
      return 'fiche-glyphe fiche-glyphe--symbole';
    case 'texte':
      return 'fiche-glyphe fiche-glyphe--texte';
    default:
      return 'fiche-glyphe';
  }
}
